import * as React from 'react'

import { Rule } from '../../rule'

export default function ThematicBreakRenderer() {
  return <Rule />
}
